import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from '../../../service/rest.service';
import { Location } from '@angular/common';
import { Message } from '../../../service/message.service';
import { LoaderService } from '../../../service/loader.service';
import { SeoService } from '../../../service/seo.service';

@Component({
  selector: 'app-enti-pubblici',
  standalone: false,
  templateUrl: './enti-pubblici.component.html',
  styleUrl: './enti-pubblici.component.scss'
})
export class EntiPubbliciComponent implements OnInit {
  constructor(private router: Router, private loader: LoaderService, private location: Location, private rest: RestService, private message: Message, private seo: SeoService) { }

 currentType = 0
  plans: any[] = []
  ngOnInit(): void {
    this.seo.updateSeo({
      title: 'Consulenza per Enti Pubblici e Bandi | Innovation Plaza',
      metadescription: 'Supportiamo enti pubblici nella gestione di bandi, finanziamenti e progetti innovativi con consulenza strategica e project management.'
    });
    const params = new URLSearchParams(window.location.search);
    const paid = params.get("paid");
    if (paid == 'false') {
      this.message.showMessage('Pagamento annullato', 'error')
    }
    if (paid == 'true') {
      this.loader.on()
      this.rest.get('/user/me').subscribe({
        next: (value) => {
          localStorage.setItem('user', JSON.stringify(value))
          this.loader.off(true)
          this.router.navigate(['profilo'])
        },
        error: (value) => {
          this.loader.off(true)
          this.router.navigate(['profilo'])
        },
      })
      this.message.showMessage('Ti sei abbonato con successo', 'success')

    }
    this.getPlans()
  }

  goTo() {
    window.location.replace('contatti')
  }

  getPlans() {
    this.rest.get('/plan').subscribe({
      next: (value: any) => {
        this.plans = value.data.map((res: any) => {
          if (res.description) {
            res.descriptions = res.description.split('/')
          }
          return res
        })
      },
    })
  }

  fakeGoTo() {
    // if (window.location.pathname == '/seleziona-piano') {
    //   // this.router.navigate(['bandi'])
    //   this.location.back();
    //    this.location.back();
    // }else{
    //   if(localStorage.getItem('token')){
    //     this.router.navigate(['profilo'])
    //   }else{
    //     this.router.navigate(['login'])
    //   }
    // }
    this.rest.post('/stripe/checkout/plan', { planId: 1 }).subscribe({
      next: (value: any) => {
        window.open(value.url)
      },
    })
  }

}


